export default "__VITE_ASSET__76d6478c__"